import React, { useEffect,useState} from "react";
import { useHistory } from "react-router-dom";
import { deleteSessionById, getSession } from "../../../redux/actions/skill";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader";

const Session = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const devices = useSelector((state) => state.skillReducer.devices);
  const sessionId = devices.length > 0 ? devices[0].id : null;
  const history = useHistory();

  useEffect(() => {
    dispatch(getSession()).then(() => {
      if (sessionId) {
        dispatch(deleteSessionById(sessionId));
      }
    });
  }, [dispatch, sessionId]);

  if (isLoading) {
    return (
      <div id="scrollableDiv" className="scrollable tl-scroll">
        <Loader styles={{ width: "80px", margin: "auto" }} root={{ display: "flex" }} />
      </div>
    );
  }

  if (devices.length === 0) {
    history.push('/dashboard/create');
    return null;
  }

  return (
    <div id="scrollableDiv" className="scrollable tl-scroll">
      <h3>Devices</h3>
    </div>
  );
};

export default Session;


